<template>
    <div class="assegnatari">
        <div class="avatar"
             v-for="a in assegnatari"
             :key="a.id"
             v-tooltip.top="a.avatar.nome_completo || [a.nome, a.cognome].filter(Boolean).join(' ')"
             :style="`background-color: ${a.avatar.colore}`">{{ a.avatar.iniziali }}</div>
        <ButtonModalForm
            v-if="allow_add"
            :dati="dati_assegnatari"
            :struttura="struttura_assegnatari"
            :action="action_assegnatari"
            :title="titolo_assegnatari"
            stilestruttura="flex flex-col gap-3 w-full"
            id="form-assegnatari"
            :testoconferma="$root.trans.salva"
            bottonesalvacontinua=""
            :testoannulla="$root.trans.annulla">
                <div class="avatar add">+</div>
            </ButtonModalForm>
    </div>
</template>
<script>
import ButtonModalForm from './ButtonModalForm.vue';

    export default{
        name: 'AssegnatariCircles',
        components:{
            ButtonModalForm
        },
        props:[
            'assegnatari',
            'allow_add',

            'titolo_assegnatari',
            'action_assegnatari',
            'dati_assegnatari',
            'struttura_assegnatari'
        ],
        mounted(){

        }
    }

</script>
